export default __webpack_public_path__ + "static/media/TheNailsBar.ba72e691.svg";